import { CombinedError } from '@/graphql';

/**
 * Error thrown when a fetch call returns a 401.
 */
export class NotAuthenticatedError extends Error {
  constructor(readonly response?: Response) {
    super('Not authenticated');
    Object.setPrototypeOf(this, NotAuthenticatedError.prototype);
  }
}

export function isNotAuthenticatedError(error: Error) {
  return (
    /* useFetch throws NotAuthenticatedError */
    error instanceof NotAuthenticatedError ||
    /* urql throws CombinedError with not auth message */
    (error instanceof CombinedError && error.message === '[Network] Not authenticated')
  );
}
